import { call, put, takeEvery, all } from 'redux-saga/effects';
import { GET_REPORT_SCHEMA, RUN_REPORT } from './actionType';
import {
  getReportSchemaSuccess,
  getReportSchemaFailure,
  runReportSuccess,
  runReportFailure,
} from './action';
import {
  getReportSchemaApi,
  runReportApi,
} from '../../helpers/fakebackend_helper';

function* getReportSchema() {
  try {
    const response = yield call(getReportSchemaApi);
    yield put(getReportSchemaSuccess(response));
  } catch (error) {
    yield put(getReportSchemaFailure(error));
  }
}

function* runReport({ payload }) {
  try {
    const response = yield call(runReportApi, payload);
    const data = Array.isArray(response) ? response[0] : response;
    // FetchAPI resolves (not throws) on failure — treat a missing row_list as an error
    if (data && Array.isArray(data.row_list)) {
      yield put(runReportSuccess(data));
    } else {
      yield put(runReportFailure(data || { status: 0 }));
    }
  } catch (error) {
    yield put(runReportFailure(error));
  }
}

function* watchGetReportSchema() {
  yield takeEvery(GET_REPORT_SCHEMA, getReportSchema);
}

function* watchRunReport() {
  yield takeEvery(RUN_REPORT, runReport);
}

export default function* ReportingSaga() {
  yield all([watchGetReportSchema(), watchRunReport()]);
}
